import { Link } from 'react-router-dom';
import styles from './WelcomeAffiliate.module.css';

function CheckIcon() {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>;
}

const POINTS = ['$0 to join', 'Four-tier commissions', 'Just share your link'];

function WelcomeAffiliate() {
    return (
        <section className={styles.affiliate} id="affiliate" data-screen-label="Affiliate intro">
            <div className={styles.affiliateInner}>
                <div className={styles.eyebrow}>Share the journey</div>
                <h2>Know someone who's been waiting for this?</h2>
                <p>Most members found TB2 through someone they trust. Our affiliate program pays you real commissions for sharing your link — no inventory, no selling, no cost to join.</p>
                <div className={styles.affPoints}>
                    {POINTS.map((point) => (
                        <div className={styles.affPoint} key={point}>
                            <span className={styles.ck}><CheckIcon /></span>{point}
                        </div>
                    ))}
                </div>
                <Link className={styles.btnPrimary} to="/affiliates?utm_source=your-journey-begins">Explore the Affiliate Program &rarr;</Link>
            </div>
        </section>
    );
}

export default WelcomeAffiliate;
